import React, { useContext, useState, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

import { Close } from "@material-ui/icons";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal, CloseAtRight, Body } from "../styles/Emissao";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

import { logsNota } from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@material-ui/lab/";

const ModalLogNFe = ({
  openModal,
  setOpenModal,
  nfeId,
  numberNfe,
  setMainLoading,
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const [logRecords, setLogRecords] = useState([]);

  useEffect(() => {
    (async () => {
      setMainLoading(true);
      const callback = await logsNota(queryParams.empresa_cnpj, nfeId);

      if (callback.success) {
        setLogRecords(callback.data);
      } else {
        setMainLoading(false);
        return notify(`Erro ao buscar os registros de log da NF ${nfeId}`);
      }
      setMainLoading(false);
    })();
  }, [nfeId, numberNfe, queryParams.empresa_cnpj, setMainLoading]);

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={openModal && logRecords.length}
      onClose={handleClose}
      aria-labelledby="dialog-log-nfe"
    >
      <HeaderModal>
        <DialogTitle id="dialog-log-nfe">
          <Grid container wrap="nowrap">
            <Chip
              label={`Informações de log da NF ${numberNfe}`}
              bgcolor="primary"
              textcolor="white"
            />
            <CloseAtRight>
              <Btn
                onClick={handleClose}
                bgcolor="red"
                hovercolor="darkred"
                startIcon={<Close />}
              />
            </CloseAtRight>
          </Grid>
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Body>
          <Grid container>
            <Grid item container xs>
              <Timeline align="alternate">
                {logRecords.map((value, index) => (
                  <TimelineItem key={index}>
                    <TimelineOppositeContent>
                      <Typography color="textSecondary">
                        {`${MaskService.dateYmdToDmy(
                          value.datahora.split(" ")[0]
                        )} às ${value.datahora.split(" ")[1]}`}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color="primary" />
                      {logRecords.length !== index + 1 && <TimelineConnector />}
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography>{`${value.descricao} por ${value.usuario?.nome}`}</Typography>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            </Grid>
          </Grid>
        </Body>
      </DialogContent>
    </Dialog>
  );
};

export default ModalLogNFe;
